"use strict";
import { ButtonBase } from "./ButtonBase.dev.js";
export class StyledButton extends ButtonBase {
}
//# sourceMappingURL=StyledButton.dev.js.map
